import React from "react";
import PropTypes from "prop-types";
import { Navigate, useParams } from "react-router-dom";
import { getFormattedPathUrl } from "../../helpers/pathFunctions";

const SFNavigateWithParams = ({ to }) => {
  const { ...allParams } = useParams();

  return <Navigate to={getFormattedPathUrl(to, allParams)} replace={true} />;
};

SFNavigateWithParams.propTypes = {
  /* The path to navigate to */
  to: PropTypes.string.isRequired,
};

export default SFNavigateWithParams;
